<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-style: normal; font-size: 1.17em;">Lorsque Mateus se mit à trembler, Crawford enroula un bras protecteur autour de ses épaules. Sa chaleur lui donna une impression d’ancrage, comme si Crawford était la seule chose physiquement capable de le maintenir à la surface.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Un centre de détention ? Ne peut-il pas tout simplement attendre ici ? Je peux avoir un avocat au téléphone dans la minute. Vous ne pouvez pas l’arrêter simplement parce qu’il se trouve ici.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Pouvait-il vraiment faire cela ? Ou n’était-ce que du bluff ? Dans un cas comme dans l’autre, c’était réconfortant.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Je regrette, monsieur, mais M. Fontes n’a aucune prétention juridique dans un pays ou dans l’autre. Il est en violation des termes de l’attribution de son visa, et pour cela, il va être arrêté. La fraude à l’immigration est un crime très sérieux.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">L’homme semblait toujours aussi compatissant, mais il y avait une note d’austérité dans sa voix. Mateus ne pensait pas vraiment que tenter de remettre son visa à jour était en soi un crime, mais apparemment, le gouvernement n’était pas du même avis.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Le bras de Crawford se resserra autour de lui, ses doigts serrant ceux de Mateus.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Il a tous les droits d’être dans ce pays. Il s’agit de mon fiancé et je suis un citoyen américain.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?6dc20334